import { z } from 'zod';

import { defaultPagingSchema } from '../../../../helpers/schemas/defaultPagingSchema';
import { searchClientSortSchema } from '../../../../helpers/search/searchClientSortSchema';

export const simpleSearchResultFormSchema = defaultPagingSchema.extend({
	searchValue: z.string().optional().nullable().catch(''),
	sort: searchClientSortSchema,
});

export type SimpleSearchResultForm = z.infer<
	typeof simpleSearchResultFormSchema
>;
